import React from "react";

const NoticeOfChangeOfName = () => {
  return <div>NoticeOfChangeOfName</div>;
};

export default NoticeOfChangeOfName;
